import React from 'react';

const EntityMiscMatters = ({ formData, handleChange }) => {
  return (
    <div>
        <fieldset className="form-field">
            <legend>
                (a) Benefit Plan Matters. The Subscriber hereby notifies the Managing Member and the Fund that the following statements are true as indicated:
            </legend>

        <fieldset className="form-field">
            <legend>
                (1) The Subscriber is <b><u>not</u></b> and will not be, for so long as Subscriber holds an interest in the Fund, a “benefit plan investor” within the meaning of Section 3(42) of ERISA, an “employee benefit plan” that is subject to Title I of ERISA, an insurance company general account, a U.S. “governmental plan” within the meaning of Section 3(32) of ERISA, a U.S. “church plan” within the meaning of Section 3(33) of ERISA, or any other entity deemed to directly or indirectly hold “plan assets” under or pursuant to ERISA.
            </legend>
            <label><input type="radio" name="entityMiscMatters.notBenefitPlanInvestor" value="true" checked={formData.entityMiscMatters.notBenefitPlanInvestor === "true"} onChange={handleChange} />
                True
            </label>
            <br />
            <label>
            <input
                type="radio"
                name="entityMiscMatters.notBenefitPlanInvestor"
                value="false"
                checked={formData.entityMiscMatters.notBenefitPlanInvestor === "false"}
                onChange={handleChange}
            />
            False
            </label>
            </fieldset>

            <fieldset className="form-field">
            <legend>
                (2) The Subscriber is an individual retirement account or annuity or other “plan” that is subject to Code §4975.
            </legend>
            <label>
            <input
                type="radio"
                name="entityMiscMatters.isRetirementPlan"
                value="true"
                checked={formData.entityMiscMatters.isRetirementPlan === "true"}
                onChange={handleChange}
            />
            True
            </label>
            <br/>
            <label>
            <input
                type="radio"
                name="entityMiscMatters.isRetirementPlan"
                value="false"
                checked={formData.entityMiscMatters.isRetirementPlan === "false"}
                onChange={handleChange}
            />
            False
            </label><br />

            {formData.entityMiscMatters.isRetirementPlan === "true" && (
            <>
                <label>and the Subscriber is an individual retirement account that is subject to Code §4975 (an “IRA”), is the decision to invest in the Fund being made by the IRA owner?</label>
                <br />
                <label>
                <input
                    type="radio"
                    name="entityMiscMatters.iraOwnerDecision"
                    value="true"
                    checked={formData.entityMiscMatters.iraOwnerDecision === "true"}
                    onChange={handleChange}
                />
                Yes
                </label>
                <br />
                <label>
                <input
                    type="radio"
                    name="entityMiscMatters.iraOwnerDecision"
                    value="false"
                    checked={formData.entityMiscMatters.iraOwnerDecision === "false"}
                    onChange={handleChange}
                />
                No
                </label>
            </>
            )}
            </fieldset>

            <fieldset className="form-field">
            <legend>
                (3) The Subscriber is an entity, account or other pooled investment fund, such as a fund of funds, the underlying assets of which are (or may in the future be (e.g., because of future fundraising)) deemed under the Plan Asset Regulation to include “plan assets” of any “employee benefit plan” subject to ERISA or “plan” subject to Code §4975.
            </legend>
            <label>
            <input
                type="radio"
                name="entityMiscMatters.isEntityetc"
                value="true"
                checked={formData.entityMiscMatters.isEntityetc === "true"}
                onChange={handleChange}
            />
            True
            </label>
            <br />
            <label>
            <input
                type="radio"
                name="entityMiscMatters.isEntityetc"
                value="false"
                checked={formData.entityMiscMatters.isEntityetc === "false"}
                onChange={handleChange}
            />
            False
            </label><br />

            {formData.entityMiscMatters.isEntityetc === "true" && (
            <>
                <label>
                    the maximum percentage of the Subscriber’s assets that may be held by Benefit Plan Investors is:
                    <span className="tab-space"></span> 
                    <input
                        type="number"
                        name="entityMiscMatters.maxBenefitPlanPercentage"
                        value={formData.entityMiscMatters.maxBenefitPlanPercentage || ""}
                        onChange={handleChange}
                        min="0"
                        max="100"
                        step="1" // Allows decimal percentages
                        placeholder="Specify maximum percentage"
                        className='textbox-input tab-space'
                    />
                    %
                </label><br />
            </>
            )}

        </fieldset>
        </fieldset>

        <fieldset className="form-field">
            <legend>
                (b) Notifications. The Subscriber hereby notifies the Managing Member and the Fund that it is (check any and all that apply):
            </legend>
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.taxExemptMember"
                    checked={formData.entityMiscMatters.taxExemptMember}
                    onChange={handleChange}
                />
                (1)	a “Tax Exempt Member” (as defined in the Fund Agreement); and/or
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.nonUSMember"
                    checked={formData.entityMiscMatters.nonUSMember}
                    onChange={handleChange}
                />
                (2)	a “Non-U.S. Member” (as defined in the Fund Agreement). 
            </label>
            <h5>
                If Subscriber selects (1) or (2) above, Subscriber hereby represents and warrants that Subscriber has discussed this investment and its tax consequences with Subscriber’s tax advisor.
            </h5>
        </fieldset>

        <fieldset className="form-field">
            <legend>
                (c)	Type of Entity.  The Subscriber represents that it is (please check all applicable categories):
            </legend>
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.corporation"
                    checked={formData.entityMiscMatters.corporation}
                    onChange={handleChange}
                />
                (1)	a corporation;
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.generalPartnership"
                    checked={formData.entityMiscMatters.generalPartnership}
                    onChange={handleChange}
                />
                (2)	a general partnership;
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.trustType"
                    value={formData.entityMiscMatters.trustType}
                    onChange={handleChange}
                />
                (3)	a limited partnership;
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.limitedLiability"
                    value={formData.entityMiscMatters.limitedLiability}
                    onChange={handleChange}
                />
                (4)	a limited liability company;
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.unincorporatedAgency"
                    value={formData.entityMiscMatters.unincorporatedAgency}
                    onChange={handleChange}
                />
                (5)	an unincorporated agency or instrumentality of the government of:
                <span className="tab-space"></span>
                <input
                    type="text"
                    name="entityMiscMatters.governmentAgency"
                    value={formData.entityMiscMatters.governmentAgency}
                    placeholder="Specify city, state, province, country and/or other jurisdiction"
                    onChange={handleChange}
                    className='textbox-input2'
                />
            </label>

            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.trust"
                    value={formData.entityMiscMatters.trust}
                    onChange={handleChange}
                />
                (6)	a trust of the following type:      
                <span className="tab-space"></span>
                <input
                    type="text"
                    name="entityMiscMatters.trustName"
                    value={formData.entityMiscMatters.trustName}
                    placeholder="e.g., charitable remainder trust, etc."
                    onChange={handleChange}
                    className='textbox-input'
                />
                <span className="tab-space"></span>
                and/or;
            </label>
            <br />
            <label>
                <input
                    type="checkbox"
                    name="entityMiscMatters.entityOther"
                    value={formData.entityMiscMatters.entityOther}
                    onChange={handleChange}
                />
                (7)	the following other form of entity:
                <span className="tab-space"></span>
                <input
                    type="text"
                    name="entityMiscMatters.entityOtherentry"
                    value={formData.entityMiscMatters.entityOtherentry}
                    placeholder="Enter other form of entity here"
                    onChange={handleChange}
                    className='textbox-input'
                />
            </label>
            <br />
        </fieldset>

        <fieldset className="form-field">
            <legend>
                (d)	Jurisdiction of Organization.  The Subscriber represents that its jurisdiction of organization is:
            </legend>
            <input
            type="text"
            name="entityMiscMatters.jurisdiction"
            value={formData.entityMiscMatters.jurisdiction}
            onChange={handleChange}
            placeholder="Enter jurisdiction"
            className='tab-space textbox-input2'
            />
        </fieldset>

        <fieldset className="form-field">
            <legend>
                (e)	Domicile.  The Subscriber represents that it is domiciled in:
            </legend>
            <input
            type="text"
            name="entityMiscMatters.domicile"
            value={formData.entityMiscMatters.domicile}
            onChange={handleChange}
            placeholder="Enter domicile"
            className='tab-space textbox-input2'
            />
            (specify state or non-U.S. jurisdiction, including the applicable city, province or other subdivision thereof).
        </fieldset>

        <fieldset className="form-field">
            <legend>
                (f)	Type of Organization.  The Subscriber represents that it is (please check only one):
            </legend>
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="brokerDealer"
                    checked={formData.entityMiscMatters.orgType === "brokerDealer"}
                    onChange={handleChange}
                />
                (1)	a broker or dealer registered pursuant to Section 15 of the Exchange Act;
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="insuranceCompany"
                    checked={formData.entityMiscMatters.orgType === "insuranceCompany"}
                    onChange={handleChange}
                />
                (2)	an insurance company as defined in Section 2(a)(13) of the Securities Act;
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="investmentCompany"
                    checked={formData.entityMiscMatters.orgType === "investmentCompany"}
                    onChange={handleChange}
                />
                (3)	an investment company registered with the U.S. Securities and Exchange Commission;
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="exemptInvestmentCompany"
                    checked={formData.entityMiscMatters.orgType === "exemptInvestmentCompany"}
                    onChange={handleChange}
                />
                (4)	an issuer that would be an “investment company” as defined in Section 3(a) of the Investment Company Act if it were not exempt from such definition due to Section 3(c)(1) or Section 3(c)(7) of the Investment Company Act;
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="nonprofit"
                    checked={formData.entityMiscMatters.orgType === "nonprofit"}
                    onChange={handleChange}
                />
                (5)	a non-profit (i.e., 501(c) or equivalent) organization;
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="pensionPlan"
                    checked={formData.entityMiscMatters.orgType === "pensionPlan"}
                    onChange={handleChange}
                />
                (6)	a pension plan (excluding governmental pension plans);
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="bankingInstitution"
                    checked={formData.entityMiscMatters.orgType === "bankingInstitution"}
                    onChange={handleChange}
                />
                (7)	a banking or thrift institution (proprietary);
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="stateGovEntity"
                    checked={formData.entityMiscMatters.orgType === "stateGovEntity"}
                    onChange={handleChange}
                />
                (8)	a state or municipal government entity;¹³
                <span className="info-icon" title={"¹³ For purposes of this item, “government entity” means any state or political subdivision of a state, including (i) any agency, authority, or instrumentality of the state or political subdivision; (ii) a plan or pool of assets controlled by the state or political subdivision or any agency, authority, or instrumentality thereof; and (iii) any officer, agent, or employee of the state or political subdivision or any agency, authority, or instrumentality thereof, acting in their official capacity."}>ⓘ</span>
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="statePensionPlan"
                    checked={formData.entityMiscMatters.orgType === "statePensionPlan"}
                    onChange={handleChange}
                />
                (9)	a state or municipal governmental pension plan; 
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="entityMiscMatters.orgType"
                    value="sovereignWealthFund"
                    checked={formData.entityMiscMatters.orgType === "sovereignWealthFund"}
                    onChange={handleChange}
                />
                (10)	a sovereign wealth fund or foreign official institution; or
            </label>
            <br />
            <label>
            <input
                type="radio"
                name="entityMiscMatters.orgType"
                value="noneOfAbove"
                checked={formData.entityMiscMatters.orgType === "noneOfAbove"}
                onChange={handleChange}
            />
            (11)	none of the above.
            </label>
        </fieldset>

        <fieldset className="form-field">
            <legend>
            (g)	Government Plans, Agencies or Units.  Is the Subscriber entitled to assert sovereign immunity or a similar defense against the enforcement of its obligations under this Subscription Agreement or the Fund Agreement?
            </legend>
            <label>
            <input
                type="radio"
                name="entityMiscMatters.governmentPlans"
                value="true"
                checked={formData.entityMiscMatters.governmentPlans === "true"}
                onChange={handleChange}
            />
            Yes
            </label>
            <br />
            <label>
            <input
                type="radio"
                name="entityMiscMatters.governmentPlans"
                value="false"
                checked={formData.entityMiscMatters.governmentPlans === "false"}
                onChange={handleChange}
            />
            No
            </label>
        </fieldset>

        <fieldset className="form-field">
            <legend>
            (h)	Freedom of Information Act.  Is the Subscriber or any of its investors subject to the Freedom of Information Act, 5 U.S.C. § 552, (“FOIA”), any state public records access laws, any state or other jurisdiction’s laws similar in intent or effect to FOIA, or any other similar statutory or regulatory requirement that might result in the public disclosure of confidential information relating to the Fund?                            
            </legend>
            <label>
            <input
                type="radio"
                name="entityMiscMatters.foiaSubject"
                value="true"
                checked={formData.entityMiscMatters.foiaSubject === "true"}
                onChange={handleChange}
            />
            Yes
            </label>
            <br />
            <label>
            <input
                type="radio"
                name="entityMiscMatters.foiaSubject"
                value="false"
                checked={formData.entityMiscMatters.foiaSubject === "false"}
                onChange={handleChange}
            />
            No
            </label>
        </fieldset>

    </div>
  );
};

export default EntityMiscMatters;
